import { Box, Checkbox, TextField, Typography } from '@mui/material'
import useAxios from '../../../hooks/useAxios'
import { useEffect, useState } from 'react'
import { IFacebookChatRoomTag } from '../../../types/facebook'

const SearchTags = () => {
  const [search, setSearch] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [debouncedSearch, setDebouncedSearch] = useState<string>(search)
  const [selectedTags, setSelectedTags] = useState<Record<string, boolean>>({})

  const { data, isLoading } = useAxios<IFacebookChatRoomTag[]>({
    method: 'GET',
    url: '/facebook/pages/chatrooms/tags',
    params: {
      search: debouncedSearch,
    },
  })

  useEffect(() => {
    setLoading(true)
    const handler = setTimeout(() => {
      setDebouncedSearch(search)
      setLoading(false)
    }, 1000)

    return () => {
      clearTimeout(handler)
      setLoading(false)
    }
  }, [search])

  const tags = data || []

  const allTagsSelected = tags?.every((tag: any) => selectedTags[tag.name])
  const someTagsSelected =
    tags.some((tag) => selectedTags[tag.name]) && !allTagsSelected

  const handleTagToggle = (tag: string) => {
    setSelectedTags((prevState) => ({
      ...prevState,
      [tag]: !prevState[tag],
    }))
  }

  const handleSelectAllTagsToggle = () => {
    const newStatus = !allTagsSelected
    setSelectedTags(
      tags.reduce(
        (acc, tag) => {
          acc[tag.name] = newStatus
          return acc
        },
        {} as Record<string, boolean>,
      ),
    )
  }

  const handleSearch = async (value: string) => {
    setSearch(value)
  }

  const currentLoadingState = loading || isLoading

  return (
    <>
      <Box>
        <TextField
          label={`ค้นหาแท็ก ${currentLoadingState ? 'กำลังโหลด...' : ''}`}
          fullWidth
          onChange={(e) => handleSearch(e.target.value)}
        />
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="body1">เลือกทั้งหมด</Typography>
          <Checkbox
            indeterminate={someTagsSelected}
            checked={allTagsSelected}
            onChange={handleSelectAllTagsToggle}
          />
        </Box>
        {tags.map((tag) => (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            key={tag.name}
            sx={{ mb: 2 }}
          >
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                  backgroundColor: tag.color,
                  mr: 1.5,
                }}
              />
              <Typography>
                {tag.name} ({tag.count ?? 0})
              </Typography>
            </Box>
            <Checkbox
              checked={!!selectedTags[tag.name]}
              onChange={() => handleTagToggle(tag.name)}
            />
          </Box>
        ))}
      </Box>
    </>
  )
}

export default SearchTags
